import { render, staticRenderFns } from "./choice-area.vue?vue&type=template&id=5aee8246&"
import script from "./choice-area.vue?vue&type=script&lang=js&"
export * from "./choice-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports